<!--
 * @Description:
 * @Author: mobai
 * @Date: 2022-04-27 09:40:47
 * @LastEditors: mobai
 * @LastEditTime: 2022-11-11 14:38:04
 * @FilePath: \qym-lishui\src\ent\views\enterprisepoints\index.vue
-->
<template>
  <div class="container">
    <!--     <nav-bar :active.sync="active"></nav-bar> -->
    <components :is="comps[active]"></components>
  </div>
</template>
<script>
import navBar from './navBar' // 导航栏
import center from './integral'
import order from './integralMall'
import { getToken } from '@utils'
export default {
  components: { navBar, center, order },
  data() {
    return {
      active: '',
      comps: ['center', 'order']
    }
  },
  created() {
    if (getToken()) {
      this.active = 0
    }
  }
}
</script>
